export const events = {
  ACTIVATE_VIEW: 'uf.views.activate',
  DUPLICATE_VIEW: 'uf.views.duplicate',
  DELETE_VIEW: 'uf.views.delete',
  EDIT_VIEW: 'uf.views.edit',
};
